import { Table as AntdTable } from "antd";

import React from "react";

const Table = (props) => {
  return <AntdTable {...props} />;
};

export default React.memo(Table);
